import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const Ethnicity = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <Donut
            title={'Cor/Raça'}
            subtitles={chartData?.ethnicity?.map((item) => item.description)}
            chartData={chartData?.ethnicity || []}
            colors={defaultColors.slice(0, chartData?.ethnicity?.length) || []}
            height={400}
            className="aligned-container"
        />
    );
};
